"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var BackgroundTaskStatusResource = /** @class */ (function (_super) {
    tslib_1.__extends(BackgroundTaskStatusResource, _super);
    function BackgroundTaskStatusResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BackgroundTaskStatusResource.endpoint = '/backgroundtaskstatuses';
    BackgroundTaskStatusResource.MODEL_NAME = 'backgroundtaskstatus';
    return BackgroundTaskStatusResource;
}(base_1.default));
exports.default = BackgroundTaskStatusResource;
//# sourceMappingURL=backgroundtaskstatus.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/backgroundtaskstatus.js
// module id = WLVs
// module chunks = 0